import axios from 'axios';

import { UpdateRestaurantResponse } from '../lib/restaurant';
import { SwornDeclarationSchemaType } from '@/components/organisms/SwornDeclarationForm/schema';
import { DigitalDeclarationSchemaType } from '@/components/pages/Restaurant/CertificatePage/schema';


export type UpdateCertificateResponse = {
  message: string;
};


export const updateRestaurantCertificate = async (restaurantId: string, params: SwornDeclarationSchemaType): Promise<UpdateRestaurantResponse> => {
  try {
    const formData = new FormData();

    if (params.certificateFile) {
      formData.append('certificate', params.certificateFile);
    }

    const { data } = await axios.put<UpdateRestaurantResponse>(`/protected/certificate/v1/${restaurantId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return data;
  } catch (error: any) {
    console.error('Erreur lors de l’appel API :', error.response?.data || error.message);
    throw error;
  }
};

export const updateRestaurantDigitalCertificate = async (restaurantId: string, params: DigitalDeclarationSchemaType): Promise<UpdateRestaurantResponse> => {
  const formData = { 
    firstName: params.firstName || '',
    lastName: params.lastName || '',
    suppliers: params.suppliers || [],
    company: params.company || null,
  }

  const { data } = await axios.put(`/protected/certificate/v2/${restaurantId}`, formData, {
    headers: {
      'Content-Type': 'application/json'
    },
  });

  return data;
};



